import React from "react";
import { CONTACT_ADDRESS, CONTACT_EMAIL, CONTACT_PHONE, CONTACT_PHONE_RAW, LOGO_SRC, MAP_URL } from "@/lib/brand";
import Mnemonic from "@/components/Mnemonic";
import SaveNumberLink from "@/components/SaveNumberLink";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="hair-t-light"
      style={{ background: "var(--mangrove-night)", color: "var(--bamboo-cream)" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24 text-center">
        <Mnemonic size={44} className="mx-auto mb-8" style={{ opacity: 0.85 }} />
        <img
          src={LOGO_SRC}
          alt="FarmStory"
          data-testid="footer-wordmark"
          className="mx-auto"
          style={{ height: 56, width: "auto", objectFit: "contain" }}
        />
        <div
          className="eyebrow mt-4"
          style={{ color: "var(--sundari-gold)" }}
          data-testid="footer-tagline"
        >
          Rooted in wonder
        </div>
        <div className="mx-auto my-8 divider-gold" />
        <div className="font-body text-[13px] tracking-wide space-y-2" style={{ opacity: 0.82 }}>
          <div data-testid="footer-address">{CONTACT_ADDRESS}</div>
          <div>
            <a
              href={MAP_URL}
              target="_blank"
              rel="noreferrer"
              className="u-link link-fade"
              data-testid="footer-directions"
              style={{ color: "var(--sundari-gold)" }}
            >
              Open in Google Maps
            </a>
          </div>
          <div className="pt-2">
            <a href={`mailto:${CONTACT_EMAIL}`} className="u-link link-fade" data-testid="footer-email">
              {CONTACT_EMAIL}
            </a>
            <span className="mx-3" style={{ opacity: 0.5 }}>·</span>
            <a href={`tel:+${CONTACT_PHONE_RAW}`} className="u-link link-fade" data-testid="footer-phone">
              {CONTACT_PHONE}
            </a>
          </div>
          <div className="pt-3">
            <SaveNumberLink tone="light" testId="footer-save-number" />
          </div>
        </div>
        <div className="mt-10 label-track" style={{ opacity: 0.5, fontSize: "10.5px" }}>
          © FarmStory · Sundarbans, West Bengal
        </div>
      </div>
    </footer>
  );
}
